








import Vue from 'vue'

import Localized from '@/components/Localized'

export default Vue.extend({
  components: { Localized },
  methods: {
    choose() {
      ;(this.$refs.nativeInput as HTMLElement).click()
      //this.$emit('change', { ...this.modelObject, [this.variable]: this.value })
    },
  },
  computed: {
    computedLocale(): string {
      return this.locale || this.$i18n.locale
    },
  },
  model: {
    event: 'change',
    prop: 'modelObject',
  },
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    modelObject: {
      type: Object,
      required: true,
    },
    label: {
      type: [String, Object],
    },
    required: {
      default: false,
      type: Boolean,
    },
    value: {
      required: true,
      type: [String, Number],
    },
    variable: {
      required: true,
      type: String,
    },
    locale: {
      type: String,
    },
  },
  watch: {
    disabled(nowIs: boolean, was: boolean) {
      if (!was && nowIs) {
        this.modelObject[this.variable] = undefined
      }
    },
  },
})
